module.exports = __webpack_public_path__ + "static/media/mulan-defi-logo-white.52db0ccf.svg";